import {InMemoryCache, defaultDataIdFromObject} from '@apollo/client';
import {SaltusAny} from './utils/SaltusAny';

export const apolloCache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        accountDetails: {
          keyArgs: ['accountId'],
        },
        accounts: {
          keyArgs: ['businessUnitIds', 'curoIds', 'search'],
        },
        bulkAccounts: {
          keyArgs: [
            'adviserEmails',
            'after',
            'before',
            'cqUpdatedDateRange',
            'first',
            'last',
            'lastAtrDateRange',
            'nextReviewDateRange',
            'noAdviser',
            'orderBy',
            'orderDirection',
            'ownerEmails',
            'propositionTypes',
            'searchTerm',
          ],
        },
        charges: {
          keyArgs: ['accountId'],
        },
        clientFiles: {
          keyArgs: ['accountId'],
        },
        contacts: {
          keyArgs: ['accountId'],
        },
        contactsSearch: {
          keyArgs: ['search'],
        },
        dashboardAccounts: {
          keyArgs: ['staffId', 'startLetter'],
        },
        documentSignaturesTemplates: {
          keyArgs: ['accountId', 'contactId'],
        },
        getFactFind: {
          keyArgs: ['contactId'],
        },
        leadsAndAccounts: {
          keyArgs: ['search'],
        },
        ovrecommends: {
          keyArgs: ['entityId', 'entityName'],
        },
        pots: {
          keyArgs: [
            'accountId',
            'contactId',
            'reviewId',
            'isSource',
            'potType',
            'planAction',
            'parentOnly',
          ],
        },
        reviews: {
          keyArgs: ['accountId', 'idType', 'onlyCurrent'],
          merge(existing = [], incoming: SaltusAny[]) {
            if (incoming.length) {
              return [...incoming];
            }
            return [...existing];
          },
        },
        tasks: {
          keyArgs: ['accountId', 'reviewId'],
        },
      },
    },
  },
  /**
   * This helps Apollo Cache stay as a flat array by manually specifying which property
   * should be considered as the ID.
   * Ultimately this prevents a stale cache as changes to a nested array will NOT be picked up.
   * */
  dataIdFromObject(responseObject) {
    switch (responseObject.__typename) {
      case 'AccountContactEdge':
        return `AccountContactEdge:${JSON.stringify(responseObject.node)}`;
      case 'AccountEdge':
        return `AccountEdge:${JSON.stringify(responseObject.node)}`;
      case 'ChargeType':
        return `ChargeType:${responseObject.id ?? JSON.stringify(responseObject)}`;
      case 'ClientCommunicationAttemptsType':
        return `ClientCommunicationAttemptsType:${responseObject.contactDate}:${responseObject.contactMethod}`;
      case 'HistoryDiffType':
        return `HistoryDiffType:${JSON.stringify(responseObject)}`;
      case 'ImagoSsoRedirectType':
        return `ImagoSsoRedirectType:${responseObject.uri}`;
      case 'InitialChargeType':
        return `InitialChargeType:${JSON.stringify(responseObject)}`;
      case 'PageInfo':
        return `PageInfo:${responseObject.startCursor}:${responseObject.endCursor}`;
      case 'ReportPackContactType':
        return `ReportPackContactType:${JSON.stringify(responseObject)}`;
      case 'ReportPackFormStatusType':
        return `ReportPackContactType:${JSON.stringify(responseObject)}`;
      case 'ReviewValidationType':
        return `ReviewValidationType:${JSON.stringify(responseObject)}`;
      case 'SharePointFileType':
        return `SharePointFileType:${responseObject.documentId}`;
      case 'SummaryChargeType':
        return `SummaryChargeType:${JSON.stringify(responseObject)}`;
      case 'XperidocExecutionDocuments':
        return `XperidocExecutionDocuments:${responseObject.link}`;
      default:
        return defaultDataIdFromObject(responseObject);
    }
  },
});
